export default function(param){
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  window.history.replaceState({}, '', `${location.pathname}?${searchParams}`);
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/helpers/remove-query-param.js